import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import App from './App.vue';
import router from './router';
import store from './store/store';

async function bootstrap() {
    const params = new URLSearchParams(window.location.search);
    const customerId = params.get('customerId');
    const token = params.get('token');
    const ts = params.get('ts');
    const adminToken = params.get('adminToken');

    if (adminToken) {
        try {
            await store.dispatch('auth/loginWithToken', adminToken);
        } catch (e) {
            // invalid/expired token — fall through to manual login
        }
        window.history.replaceState(null, '', window.location.pathname);
    } else if (customerId && token && ts) {
        try {
            await store.dispatch('auth/ssoLogin', { customerId, token, ts });
        } catch (e) {
            // SSO failed — fall through to normal manual login
        }
        window.history.replaceState(null, '', window.location.pathname);
    } else if (store.getters['auth/isAuthenticated'] && !store.getters['auth/dealer']) {
        // Existing token from a prior session (e.g. plain page reload, no fresh
        // SSO/admin params this load) — dealer info isn't persisted, only the token is.
        try {
            await store.dispatch('auth/fetchMe');
        } catch (e) {
            // Token no longer valid server-side — clear it so the router sends them to login
            store.dispatch('auth/logout');
        }
    }

    const app = createApp(App);
    app.use(ElementPlus);
    app.use(router);
    app.use(store);
    app.mount('#app');
}

bootstrap();
